import React from "react";

const PolicyBlock = ({ block }) => (
  <div className="pp-block">
    {block.subheader ? <h4>{block.subheader}</h4> : null}
    {block.prose ? <p>{block.prose}</p> : null}
    {block.email ? (
      <a className="pp-email-link" href={`mailto:${block.email}`}>
        {block.email}
      </a>
    ) : null}
    {block.bullets?.length ? (
      <ul>
        {block.bullets.map((item) => (
          <li key={item}>{item}</li>
        ))}
      </ul>
    ) : null}
  </div>
);

const PolicySectionBody = ({ section }) => (
  <div className="pp-section-body">
    {section.lead ? <p className="pp-lead">{section.lead}</p> : null}
    {section.bullets?.length ? (
      <ul>
        {section.bullets.map((item) => (
          <li key={item}>{item}</li>
        ))}
      </ul>
    ) : null}
    {section.blocks?.map((block) => (
      <PolicyBlock key={block.subheader || block.prose} block={block} />
    ))}
    {section.footnote ? <p className="pp-footnote">{section.footnote}</p> : null}
  </div>
);

const PolicySectionAccordion = ({ section, open, onToggle }) => (
  <article
    id={`pp-${section.id}`}
    className={`pp-section${open ? " pp-section-open" : ""}`}
  >
    <button type="button" className="pp-section-head" onClick={onToggle} aria-expanded={open}>
      <span className="pp-section-index" aria-hidden>
        {section.index}
      </span>
      <span className="pp-section-title-wrap">
        <em>Section</em>
        <strong>{section.title}</strong>
      </span>
      <span className="pp-section-chevron" aria-hidden />
    </button>
    {open ? (
      <div className="pp-section-panel">
        <PolicySectionBody section={section} />
      </div>
    ) : null}
  </article>
);

export { PolicySectionAccordion, PolicySectionBody };
